module.exports = {
    // basic

    // raw
    'delete-well-group-failed-title': `Cannot delete well group`,
    'delete-well-group-failed-reason': 'This well group is currently in use in the following places:'
    // template
};